import { types } from '../actions/types';

const DEFAULT_STATE = {
    videoCodeVerified: false,
    session: null,
    isEndCallDialogOpen: false,
    endCallNavigationLocation: '/',
}

export default (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case types.VIDEO_CODE_VERIFIED:
            return {
                ...state, isVerified: action.payload
            }
        case types.SESSION_DATA:
            console.log('GOT SESSION DATA AT REDUCER', action.payload);
            return {
                ...state, session: action.payload
            }
        case types.RECEIVED_TOKEN_SUCCESS:
        console.log('GOT TOKEN AT REDUCER', action.payload);
        return {
                ...state, token: action.payload
            }
        case types.RECEIVED_TOKEN_FAIL:
            return {
                ...state, token: action.payload
            }
        case types.CONFIRM_END_CALL_DIALOG_OPEN:
        // console.log('action.payload', action.payload)
            return {
                ...state, isEndCallDialogOpen: action.payload
            }
        case types.CONFIRM_END_CALL_DIALOG_CLOSE:
            return {
                ...state, isEndCallDialogOpen: action.payload
            }
        case types.CONFIRM_END_CALL_NAVIGATION_LOCATION:
            return {
                ...state, endCallNavigationLocation: action.payload
            }
        case types.GET_OTHER_VIDEO_USERS_DATA_BY_TYPE_SUCCESS:
            return {
                ...state, otherUser: action.payload
            }
        case types.GET_CONSULT_SERVICE_DATA_SUCCESS:
            return {
                ...state, service: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/video-reducer.js